import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { setErrors } from "./errorReducers";
import { apiClient } from "../../zodios/client";
import type { AmazonOnboardingStatus } from "../../zodios/apiDefinitions/api/amazonOnboarding";

const initialState = {
  amazon_advertising_access: "",
  org_status: "",
  listings_progress: "",
  category_progress: "",
  stock_progress: "",
  remainder_days: null as number | null,
  amazon_spapi_access: "",
  eu_amazon_spapi_access: "",
  fe_amazon_spapi_access: "",
};

const amzOnboardSlice = createSlice({
  name: "amz_onboard",
  initialState,
  reducers: {
    updateAmzOnboardingStatus: (state, action: PayloadAction<AmazonOnboardingStatus>) => {
      // For Walmart/Shopify orgs, most fields are optional - use defaults
      state.amazon_advertising_access = action.payload.amazon_advertising_access ?? "";
      state.org_status = action.payload.org_status;
      state.listings_progress = action.payload.listings_progress ?? "";
      state.category_progress = action.payload.category_progress ?? "";
      state.stock_progress = action.payload.stock_progress ?? "";
      state.remainder_days = action.payload.remainder_days ?? null;
      state.amazon_spapi_access = action.payload.amazon_spapi_access ?? "";
      state.eu_amazon_spapi_access = action.payload.eu_amazon_spapi_access ?? "";
      state.fe_amazon_spapi_access = action.payload.fe_amazon_spapi_access ?? "";
    },
    resetAmzOnboarding: () => {
      return initialState;
    },
  },
});

export const { updateAmzOnboardingStatus, resetAmzOnboarding } = amzOnboardSlice.actions;
export default amzOnboardSlice.reducer;

export const refreshAmzOnboardStatus = (
  dispatchUpdateAmzOnboardingStatus: (status: AmazonOnboardingStatus) => void,
  dispatchSetErrors: typeof setErrors,
) => {
  apiClient
    .getAmazonOnboardingStatus()
    .then((amzOnboardingStatus) => {
      dispatchUpdateAmzOnboardingStatus(amzOnboardingStatus);
    })
    .catch((err) => {
      dispatchSetErrors(err);
    });
};
